import { Component, signal, inject } from '@angular/core';
import { OffcanvasService } from '../../../../../_services/offcanvas-service/offcanvas.service';
import { EmployeeService } from '../../../../../_services/employee-service/employee.service';
import { OffcanvasBaseComponent } from '../../../../../shared/components/offcanvas/offcanvas-base/offcanvas-base.component';

@Component({
  selector: 'app-add-employee-landing',
  imports: [OffcanvasBaseComponent],
  templateUrl: './add-employee-landing.component.html',
})
export class AddEmployeeLandingComponent {
  readonly offcanvasService = inject(OffcanvasService);
  readonly employeeService = inject(EmployeeService);

  protected returnUrl = signal(this.employeeService.conditionalReturnUrl());

  addNewEmployeeDetails() {
    return this.offcanvasService.offCanvasNavigate(`${this.returnUrl()}/add/employee-details`);
  }

  openBulkUploads() {
    this.offcanvasService.offCanvasNavigate(`${this.returnUrl()}/bulk-upload-template`);
  }
}
